import o from "react";
const h = ({
  elementRef: r,
  filters: s = [],
  isActive: n = !0,
  clickEvents: e = ["mousedown", "touchstart"],
  callback: c
}) => {
  o.useEffect(() => {
    const u = (t) => {
      const i = t.target, f = r.current, a = f && !f.contains(i), d = s.every((m) => !i.closest(m));
      a && d && c(t);
    };
    if (!n) {
      e.forEach((t) => {
        document.removeEventListener(t, u);
      });
      return;
    }
    return e.forEach((t) => {
      document.addEventListener(t, u, { passive: !0 });
    }), () => {
      e.forEach((t) => {
        document.removeEventListener(t, u);
      });
    };
  }, [r, s, n, e, c]);
}, v = (r, s) => {
  const n = o.useRef(null), e = s ?? n;
  return o.useEffect(() => {
    e.current && (r ? e.current.setAttribute("inert", "") : e.current.removeAttribute("inert"));
  }, [r, e]), { ref: e };
};
export {
  v as a,
  h as u
};
